import * as Types from '../constants/Types';

export const getListPromotions = (filters) => ({type: Types.PROMOTION_LIST_ACTION, filters});
export const dataPromotionSuccess = (promotions) => ({type: Types.PROMOTION_LIST_SUCCESS, promotions});

export const changeStatusCode = (id, bundleName, note, status, filters) => ({ type: Types.PROMOTION_CHANGE_STATUS_CODE_ACTION, id, note, bundleName, status, filters });
export const changeStatusCodeSuccess = (promotionId, status) => ({ type: Types.PROMOTION_CHANGE_STATUS_CODE_SUCCESS, promotionId, status });

export const getAllCampaign = () => ({ type: Types.PROMOTION_CAMPAIGN_LIST_ACTION });
export const getAllCampaignSuccess = (campaigns) => ({ type: Types.PROMOTION_CAMPAIGN_LIST_SUCCESS, campaigns });

export const getAllCampaignFilter = (filters) => ({ type: Types.PROMOTION_CAMPAIGN_LIST_FILTER_ACTION, filters });
export const getAllCampaignFilterSuccess = (campaigns) => ({ type: Types.PROMOTION_CAMPAIGN_LIST_FILTER_SUCCESS, campaigns });

export const getBundlesByCampaignId = (campaignId) => ({ type: Types.BUNDLE_LIST_ACTION, campaignId });
export const getBundlesByCampaignIdSuccess = (bundles) => ({ type: Types.BUNDLE_LIST_SUCCESS, bundles });

export const exportExcel = (params) => ({ type: Types.PROMOTION_EXPORT_FILE_ACTION, params }) 

export const resetDataCheck = (code) => ({ type: Types.CHECK_PROMOTION_RESET, code });
export const checkPromotion = (code) => ({ type: Types.CHECK_PROMOTION_ACTION, code });
export const checkPromotionSuccess = (result) => ({ type: Types.CHECK_PROMOTION_SUCCESS, result });
export const getHistoryCode = (filters) => ({ type: Types.PROMOTION_GET_HISTORY_CODE_ACTION, filters })
export const getHistoryCodeSuccess = (histories) => ({type: Types.PROMOTION_GET_HISTORY_CODE_SUCCESS, histories})

export const resetHistoryCode = () => ({ type: Types.PROMOTION_GET_HISTORY_CODE_RESET });

export const bulkUpdatePromotionStatus = (params, filters) => ({type: Types.PROMOTION_BULK_UPDATE_STATUS_ACTION, params, filters});

// Bundles
export const getListBundles = (filters) => ({type: Types.BUNDLES_LIST_ACTION, filters});
export const setListBundlesSuccess = (bundles) => ({type: Types.BUNDLES_LIST_SUCCESS, bundles});

export const getBundlesDetails = (id) => ({ type: Types.BUNDLES_DETAIL_ACTION, id });
export const setBundlesDetails = (bundle) => ({ type: Types.BUNDLES_DETAIL_SUCCESS, bundle });

export const updateBundlesDetails = (bundle) => ({ type: Types.BUNDLES_UPDATE_ACTION, bundle });

export const createBundlesDetails = (bundle) => ({ type: Types.BUNDLES_CREATE_ACTION, bundle });

export const changeBundleStatus = (bundle) => ({ type: Types.BUNDLES_DEACTIVATED_CODE_ACTION, bundle });
export const changeBundleStatusSuccess = (id, status) => ({ type: Types.BUNDLES_DEACTIVATED_CODE_SUCCESS, id, status });

export const parseExcel = (file) => ({ type: Types.BUNDLES_PARSE_EXCEL_ACTION, file });
export const parseExcelSuccess = (file) => ({ type: Types.BUNDLES_PARSE_EXCEL_SUCCESS, file });
export const parseExcelClearData = () => ({ type: Types.BUNDLES_PARSE_EXCEL_CLEAR_ERROR });

// AutoFill
export const getListAutoFill = (filters) => ({type: Types.AUTOFILL_LIST_ACTION, filters});
export const setListAutoFillSuccess = (autoFill) => ({type: Types.AUTOFILL_LIST_SUCCESS, autoFill});

export const createAutoFill = (autoFill) => ({ type: Types.AUTOFILL_CREATE_ACTION, autoFill });
export const getAutoFillDetails = (id) => ({ type: Types.AUTOFILL_DETAIL_ACTION, id });
export const setAutoFillDetailSuccess = (autoFill) => ({type: Types.AUTOFILL_DETAIL_SUCCESS, autoFill});
export const updateAutoFill = (autoFill) => ({ type: Types.AUTOFILL_UPDATE_ACTION, autoFill });

// Import excel active/de-active
export const importFile = (file) => ({ type: Types.IMPORT_FILE_ACTION, file });
export const importFileSuccess = (file) => ({ type: Types.IMPORT_FILE_SUCCESS, file });

// Change status group
export const updateStatusGroup = (dataGroupCode) => ({ type: Types.UPDATE_STATUS_GROUP_ACTION, dataGroupCode });
export const updateStatusGroupSuccess = () => ({ type: Types.UPDATE_STATUS_GROUP_SUCCESS });

export const getSampleFileStatus = () => ({ type: Types.GET_FILE_STATUS_SAMPLE_ACTION });
export const getSampleFileStatusSuccess = (file) => ({ type: Types.GET_FILE_STATUS_SAMPLE_SUCCESS, file });
export const clearStatusGroup = () => ({ type: Types.CLEAR_STATUS_GROUP });

